import {MenuItem, Select} from '@mui/material';
import {useTranslation} from "react-i18next";
import React from 'react';

function YearSelect(props) {
	const {year, yearChange, allowNone, enabled} = props;
	let y = new Date().getYear() + 1900, i;
	const {t} = useTranslation('obs');
	let y_list = [];

	if (allowNone)
		y_list.push(0);

	for (i = y; i >= 1990; i--) 
		y_list.push(i);
	
	return (
		<Select 
		    size='small'
		    value={year}
		    onChange={yearChange}
		    disabled={enabled === undefined ? false : !enabled}
		>
		{y_list.map((_y, ind) => {
			if (_y === 0)
				return (<MenuItem key={0} value={0}>{t('stats.none')}</MenuItem>);

			return (<MenuItem key={_y} value={_y}>{_y}</MenuItem>);
		})}
		</Select>
	);
}

export default YearSelect;
